import AxiosJob from '@/services/api/job/axios_job'

export default {
  // Create a link between a job and a node
  createJobFile: (data) => {
    // data: { job_id, node_id, job_file_type }
    return AxiosJob.post('job-file', data)
  },

  // Update a job-file link
  updateJobFile: (jobFileId, data) => {
    return AxiosJob.put(`job-file/${jobFileId}`, data)
  },

  // Get a single job-file record
  getJobFile: (jobFileId) => {
    return AxiosJob.get(`job-file/${jobFileId}`)
  },

  // Delete a job-file link
  deleteJobFile: (jobFileId) => {
    return AxiosJob.delete(`job-file/${jobFileId}`)
  },

  // List job files for a job
  listJobFiles: (jobId, params = {}) => {
    // params: { order, direction, offset, limit }
    return AxiosJob.get(`job/${jobId}/job-files`, { params })
  },

  // List job files by type (1=reference, 2=material)
  listJobFilesByType: (jobId, jobFileType, params = {}) => {
    return AxiosJob.get(`job/${jobId}/job-files/type/${jobFileType}`, { params })
  },
}

